import { useUser } from 'apps/shared/scripts/graphql';

import { PRO_MODE_ENABLED } from '../../constants';

const ALLOWLISTED_IDS: string[] = [];

const useFeatureGate = (id: string) => {
  const { isLoading, user } = useUser();

  if (isLoading || !user) {
    return false;
  }

  if (id === PRO_MODE_ENABLED) {
    if (ALLOWLISTED_IDS.includes(user.id)) {
      return true;
    }
    return false;
  }

  return false;
};

export default useFeatureGate;
